// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"030f3183","453":"19b39ba7","455":"9ef2784d","977":"9cdca7b3"}[chunkId] + ".chunk.js";
};